import { startCase } from 'lodash-es'
import type { DocumentStep, UIDocumentStep } from './types'

export function getDisplayStep(step: UIDocumentStep | DocumentStep): string {
  switch (step) {
    case 'clustering':
      return 'Clustering'
    case 'classification':
      return 'Classification'
    case 'data':
      return 'Data Extraction'
    case 'carc_rarc':
      return 'Tagging'
    case 'patient':
      return 'Matching'
    case 'eob_payment_deposit':
      return 'Payment Deposit'
    case 'eob_duplication':
      return 'Duplication'
    case 'eob_processing':
      return 'EOB Processing'
    case 'processing':
      return 'Processing'
    default:
      return startCase(step)
  }
}
